export const Functions = {
  create: false,
  delete: true,
  detail: false,
  search: true
};
export const PageName = '资产记录';